import React from 'react'
import { Link } from 'gatsby'
import * as styles from './HowToParticipate.module.scss'
import step1 from 'images/home/step-1.png'
import step2 from 'images/home/step-2.png'
import step3 from 'images/home/step-3.png'
const HowToParticipate = ({url}) => {
  return (
    <section className={styles.howToParticipate}>
      <div className={styles.contentHeader}>
        <div className={styles.container}>
          <h2 className={styles.howToParticipateHeading}>
            Learn How To Participate
          </h2>
          <p className={styles.howToParticipateContent}>
            From our Family to yours, save more when you buy more. Start the
            year fresh with up to a $10 Digital Visa® Prepaid Card when you buy
            up to $30 of Colgate-Palmolive products.
          </p>
        </div>
      </div>
      <div className={styles.steps}>
        <div className={`${styles.step} ${styles.imageStep}`}>
          <img src={step1} alt="step 1 shop" />
        </div>
        <div className={styles.step}>
          <h3 className={styles.stepHeader}>1. Shop</h3>
          <p className={styles.stepContent}>
            Shop your favorite Colgate-Palmolive brands.
          </p>
          <Link className={styles.stepButton} to="/brands">
            See Participating Brands
          </Link>
        </div>

        <div className={styles.step}>
          <h3 className={styles.stepHeader}>2. Upload</h3>
          <p className={styles.stepContent}>
            Upload a picture of your receipt.
          </p>
          <Link
            to={url}
            className={styles.stepButton}
          >
            Upload My Receipt
          </Link>
        </div>
        <div className={`${styles.step} ${styles.imageStep}`}>
          <img src={step2} alt="step 2 upload" />
        </div>
        <div className={`${styles.step} ${styles.imageStep}`}>
          <img src={step3} alt="step 3 redeem" />
        </div>
        <div className={styles.step}>
          <h3 className={styles.stepHeader}>3. Redeem</h3>
          <p className={styles.stepContent}>Redeem your rewards.</p>
          <Link to="/store/" className={styles.stepButton}>
            See Rewards
          </Link>
        </div>
      </div>
    </section>
  )
}

export default HowToParticipate
